const appConstants = {
  _API_ROOT_URL: 'http://localhost/imsproapi/',
  API_ROOT_URL: 'https://ilmcampus.in/inst/imsproapi/',
  COLORS: {
    APP_BG_COLOR: '#136FF8',
    BUTTON_BG_COLOR: '#0657CE',
    BUTTON_COLOR: '#ffffff',
    TEXT_COLOR: '#ffffff',
    TEXT_COLOR_BLACK: '#000000',
    TABLE_COLOR: '#0657CE',
  },
  SCREEN_SHOT: {
    TITLE: "IMS",
    TEXT: "",
  }
};

export default appConstants;
